import { useState } from 'react';
import { faqs } from '@/mocks/filmData';

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50">
      <div className="px-5 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3 mb-3">
              <span className="w-10 h-10 rounded-md bg-secondary-100 text-secondary-900 flex items-center justify-center">
                <i className="ri-question-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="text-xs font-medium tracking-widest text-secondary-700 uppercase">FAQ</span>
            </div>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">常见问题</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              关于中文字幕、中文版、国语与双语的选择，读者最常关心的几个问题整理在这里。
            </p>
          </div>

          <div className="lg:col-span-8">
            <div className="space-y-3">
              {faqs.map((item, i) => {
                const isOpen = open === i;
                return (
                  <div key={item.q} className="rounded-lg border border-background-200 bg-background-100 overflow-hidden">
                    <button
                      type="button"
                      aria-expanded={isOpen}
                      onClick={() => setOpen(isOpen ? null : i)}
                      className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 cursor-pointer"
                    >
                      <span className="font-medium text-sm md:text-base text-foreground-950">{item.q}</span>
                      <span className="w-7 h-7 shrink-0 rounded-full bg-background-50 text-primary-600 flex items-center justify-center">
                        <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} aria-hidden="true"></i>
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-4 -mt-1">
                        <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}